module.exports = __webpack_public_path__ + "media/images/map_icons/Softball-57f25eb272b29fef83d4f657e79b600c.svg";